import { GetterTree } from 'vuex';
import { NavigationState } from './types';

const getters: GetterTree<NavigationState, any> = {
  receivedAppsCount: (state) => state.receivedAppsCount,
};

export default getters;
